import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class InterventionService {
  getInterventionTypes() {
    return axios
      .get(`${config["apiUrl"]}intervention/type`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInterventionsByType(typeId) {
    return axios
      .get(`${config["apiUrl"]}intervention/${typeId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInterventionsPat(userId, start, end, search = "") {
    let url = `${config["apiUrl"]}intervention/pats/user/${userId}/${start}/${end}`;
    if (search) {
      url += `?search=${search}`;
    }

    return axios
      .get(
        url,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getTypes() {
    return axios
      .get(`${config["apiUrl"]}intervention/types`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  queryPats(params) {
    return axios
      .get(`${config["apiUrl"]}intervention/query-pats`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPatContacts(patNumbers) {
    let params = {};
    if (Array.isArray(patNumbers)) {
      params.pat_numbers = patNumbers.join(',');
    } else if (patNumbers) {
      params.pat_number = patNumbers;
    }
    return axios
      .get(`${config["apiUrl"]}intervention/pat-contacts`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return [];
      })
      .catch((error) => {
        if (error && error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error);
        return [];
      });
  }
}
export default new InterventionService();
